import { getFileInfoState } from './getFileInfoState';
import { getModalFileData } from './getModalFileData';
import { getFileUploadProgressState } from './getFileUploadProgressState';
import { FileHelperService } from '../services';
import { createSelector } from 'reselect';
export const getModalFileDataList = createSelector([getFileInfoState, getFileUploadProgressState], (fileInfoState, fileUploadProgressState) => {
    const fileDataList = [];
    for (let index = 0; index < fileInfoState.allIds.length; index++) {
        const fileId = fileInfoState.allIds[index];
        const currentFileInfo = fileInfoState.byId[fileId];
        const fileUploadProgress = fileUploadProgressState.byId[fileId] || {};
        if (FileHelperService.isNonCancelledOriginalFile(currentFileInfo)) {
            const fileData = getModalFileData(fileInfoState, fileId);
            fileDataList.push(Object.assign(Object.assign({}, fileData), { progress: fileUploadProgress.progress }));
        }
    }
    return fileDataList;
});
//# sourceMappingURL=getModalFileDataList.js.map